import styled from 'styled-components';

const Hero = styled.div`
  margin-top: 8px;
`;

export default Hero;
